import React from 'react';
import PropTypes from 'prop-types';
import 'react-responsive-carousel/lib/styles/carousel.css';
import { Effect, Modal, ModalManager } from 'react-dynamic-modal';
import tracking from '../services/Tracking';

// Import i18n messages
import { IntlProvider, FormattedMessage } from 'react-intl';
import { translationMessages, lang } from '../i18n';

class HatchModal extends React.Component {
  onClickLink(retailer) {
    tracking.event(retailer.name, 'buy-now-hatch');
  }

  render() {
    const { retailers, onRequestClose } = this.props;
    return (
      <IntlProvider locale={lang} key={lang} messages={translationMessages.current}>
        <Modal
          onRequestClose={onRequestClose}
          effect={Effect.RotateFromBottom3D}>
          <h2 className="modal-headline"><FormattedMessage id="hatchModal.title" /></h2>
          {retailers.map((retailer, i) => (
            <div className="hatch-retailer" key={i}>
              <a onClick={() => this.onClickLink(retailer)} href={retailer.purchase_link} data-retailer={retailer.name} target="_blank">
                <span className="hatch-retailer-button"><span className="gui-button"><FormattedMessage id="hatchModal.buyNow" /></span></span>
                <span className="hatch-retailer-logo">
                    <img src={retailer.logo} alt={retailer.name} />
                  </span>
                <span className="hatch-retailer-stockinfo"><FormattedMessage id="hatchModal.stockInfo" values={{stockQuantity: retailer.stock_qty}} /></span>
              </a>
            </div>
          ))}
          <button className="modal-close" onClick={ModalManager.close} />
        </Modal>
      </IntlProvider>
    );
  }
}

HatchModal.propTypes = {
  retailers: PropTypes.array,
  onRequestClose: PropTypes.func,
};

export default HatchModal;


// WEBPACK FOOTER //
// ./src/components/HatchModal.js